import { render, staticRenderFns } from "./ReportPosition.vue?vue&type=template&id=60e631d7&"
import script from "./ReportPosition.vue?vue&type=script&lang=js&"
export * from "./ReportPosition.vue?vue&type=script&lang=js&"
import style0 from "./ReportPosition.vue?vue&type=style&index=0&id=60e631d7&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports